import React from 'react';
import { getApplicantName } from '../utils/visaApplicationFilters';
import { isFormFilled } from '../utils/visaApplicationData';

const ApplicantNameCell = ({ data, application }) => {
  const filled = application?.form_filled ?? isFormFilled(data);
  const versionLabel =
    application?.form_version_label ||
    (application?.form_version > 0 ? `v${application.form_version}` : null);

  if (!filled) {
    return <span className="text-amber-600">Form pending</span>;
  }

  return (
    <span className="inline-flex items-center gap-2 flex-wrap">
      <span>{getApplicantName(data)}</span>
      {versionLabel && (
        <span className="inline-flex px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-indigo-50 text-indigo-700">
          {versionLabel}
        </span>
      )}
    </span>
  );
};

export default ApplicantNameCell;
